<template>
     <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="alcohol-modal">
          <div class="content-container">
            <p class="session-modal-title">Sorry</p>
            <p class="alcohol-modal-p">Alcohol is only available for purchase in California. </p>
            <p class="session-modal-p">Remove the following alcohol-related items from the cart?</p>
              <div class="cart-item-container">
                <div class="cart-item" v-for="(item, index) in this.alcoholItemsToBeRemoved">
                  <div class="cart__image-wrapper" ><img class="table-image" :src="item.Thumbnail" alt=""></div>
                      <div class='alcohol-product-name'>
                        <p v-if='$i18n.locale=="en"' class="product-name">{{productTitle(item)}}</p>
                        <p v-if='$i18n.locale=="ch"' class="product-name">{{item.Description}}</p>
                        <p class="unit-price">${{item.UnitPrice.toFixed(2)}}</p>
                      </div>
                    </div>
                  </div>
                <div class="alcohol-button-container">
              <button class="alcohol-confirm" @click="toggleAlcoholModal(false)">Select New Address</button>
              <button class="alcohol-confirm" @click="clearAlcoholItems">Clear Alcohol</button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'alcoholModal',
    props: ['clearAlcoholItems', 'toggleAlcoholModal', 'alcoholItemsToBeRemoved'],
  data() {
    return {
    }
  },
  methods: {
    ...mapMutations('navbar', ['validateRadiusPurchase' ]),
        productTitle(item) {
      if (!this.business) {
        return item.Name
      }
      if (this.business) {
        if (item.ProductNum.charAt(item.ProductNum.length -1) === '0') {
          return item.Name + '(Master Case)';
        }
        if (item.ProductNum.charAt(item.ProductNum.length -1) === '2') {
          return item.Name + '(Inner Case)';
        } else {
          return item.Name
        }
      }
    },
  },
  watch: {
    alcoholItemsToBeRemoved: function(newVal, oldVal) {
      console.log("newVal:", newVal);
    }
  },
  computed: mapState({
    showModal: state => state.navbar.showModal,
  }), 
}
</script>


<style lang="less">
  @import "../../assets/css/refreshSession.less";
</style>



// WEBPACK FOOTER //
// src/view/Modal/alcoholModal.vue